import Component from "@glimmer/component"
import type { GoogleClassroomPostType, LessonCard } from "@shared/models/card-stack"

interface Signature {
  Args: {
    toggleCardMenu: () => void
    usedAs: "lesson" | "lesson-template" | "unit"
    addCardToBottom: (type: LessonCard["type"], postType: GoogleClassroomPostType) => void
  }
}

export default class AddGooglePostBody extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::AddCard::GoogleClassroomPost::Body": typeof AddGooglePostBody
  }
}
